import actionTypes from 'src/constants/actionTypes';
import featuredCollectionsService from 'src/services/featuredCollections';

function handleCommonAction(actionPrefix, serviceAction, values = null) {
  return dispatch => {
    dispatch({ type : actionTypes[`FEATURED_COLLECTION__${actionPrefix}_START`] });

    return featuredCollectionsService[serviceAction](values)
      .then(data => {
        const key = Object.keys(data)[0];

        return dispatch({
          type    : actionTypes[`FEATURED_COLLECTION__${actionPrefix}_SUCCESS`],
          payload : { data : data[key] },
        });
      })
      .catch(errors => dispatch({
        type    : actionTypes[`FEATURED_COLLECTION__${actionPrefix}_FAILURE`],
        payload : { errors },
      }));
  };
}

export function add(values) {
  return handleCommonAction('ADD', 'add', values);
}

export function clearTempState() {
  return { type : actionTypes.FEATURED_COLLECTION__CLEAR_TEMP_STATE };
}

export function getAll(values) {
  return handleCommonAction('GET_ALL', 'getAll', values);
}

export function show(values) {
  return handleCommonAction('SHOW', 'show', values);
}
